import { ActivatedRoute } from '@angular/router';
import { Component, Input, OnInit } from '@angular/core';
import { LoadingController, ModalController, Platform } from '@ionic/angular';
import { PaymentService } from 'src/app/services/payment/payment.service';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { HttpClient, HttpHeaders } from '@angular/common/http';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as moment from 'moment';

import { Directory } from '@capacitor/filesystem';
import { CmsService } from 'src/app/services/cms/cms.service';
import { errorMessages } from 'src/app/interfaces/error-messages';
import { Filesystem, FilesystemDirectory } from '@capacitor/filesystem';
import { FileOpener } from '@ionic-native/file-opener/ngx';
import { UserService } from 'src/app/services/user/user.service';
import { DatePipe, CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-receipt-student',
  templateUrl: './receipt-student.page.html',
  styleUrls: ['./receipt-student.page.scss'],
  providers:[DatePipe, CurrencyPipe]
})
export class ReceiptStudentPage implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private loadingCtrl: LoadingController,
    private plt: Platform,
    private fileOpener: FileOpener,
    private http: HttpClient,
    protected userService: UserService,
    private cmsService: CmsService, 
    private paymentService: PaymentService,
    private currencyPipe: CurrencyPipe,
    private datePipe: DatePipe
  ) { }
  transaction:any;
  paymentId;
  studentId;
  pdfObj;
  paymentMethod;
  paymentDate;
  validationDate;
  showButtons = true;
  billToDetails;
  firstName;
  middleName;
  lastName;
  extensionName;
  region;
  province;
  city;
  barangay;
  block;
  postalCode;
  studentAddress;
  studentCourse;
  studentCourseDetails;
  studentCourseId;
  studentCourseName;
  studentCourseDescription;
  dsProfileImg;
  school;
  fileDownloaded:boolean=false;
  studentProfile;

  ngOnInit() {    
    this.fileDownloaded= false;

  }

  ionViewDidEnter() {
    this.studentId = this.route.snapshot.params['studentId'];
    this.paymentId = this.route.snapshot.params['paymentId']; 
    this.paymentService.getTransactionDetails(this.studentId) 
    .then((trans: any) => {
      this.transaction = trans.result[0];
      //console.log( this.transaction )
      //console.log(this.transaction.dsProfileId);

      this.userService.getStudentProfile(this.studentId) .then((profile: any) => {
        this.studentProfile = profile.result[0];
        //console.log(  this.studentProfile )
        this.studentAddress =  this.studentProfile.address.block+" "+  this.studentProfile.address.barangay+"\n "
        + this.studentProfile.address.city +"\n "+  this.studentProfile.address.province +" "+  this.studentProfile.address.postalCode;
        this.billToDetails = this.studentProfile.fullName +"\n " + this.studentAddress;

        if (this.transaction) {
          this.paymentMethod = this.transaction.paymentMethodCode.replace('_', ' ');
          this.paymentDate = this.datePipe.transform(
            this.transaction.paymentDate,
            'yyyy-MM-dd'
          );
    
          if (this.transaction.validationDate) {
            this.validationDate = this.datePipe.transform(
              this.transaction.validationDate,
              'yyyy-MM-dd'
            );
          }
        }
      }
      );

      this.userService
      .getDsProfileById(this.transaction.dsProfileId)
      .then((school: any) => {
        this.school = school.result[0];
        //console.log(this.school);          
        this.getDSProfileImage(this.school.logo);
      });
    });
    this.generatePdf();
  }

  getBlobForDSNoPhoto() {
    this.http
      .get('assets/img/cert/nophoto.jpg', {
        responseType: 'blob',
      })
      .subscribe((res) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          this.dsProfileImg = reader.result;
        };
        reader.readAsDataURL(res);
      });
  }

  getDSProfileImage(profileImg) {
    fetch(profileImg)
      .then((res) => res.blob())
      .then((res) => {
        //console.log(res);
        const reader = new FileReader();
        reader.onloadend = () => {
          this.dsProfileImg = reader.result;
        };
        reader.readAsDataURL(res);
      })
      .catch((err) => {
        this.getBlobForDSNoPhoto();
      });
  }


  formatMoney(value) {
    const temp = `${value}`.replace(/\,/g, "");
    return this.currencyPipe.transform(temp).replace("$", "");
} 

    // generating invoice

    loading;
    async generatePdf() {
      this.loading = await this.loadingCtrl.create({
        cssClass: 'my-custom-class',
        message: 'Generating Receipt, please wait to download the PDF file...',
      });
      await this.loading.present();
      var dd = {
        pageSize: 'LETTER', //pageSize: { width: 612.00, height: 792.00},
        pageMargins: [60.5, 0, 0, 0],
        content: [
          {
            text: 'PAYMENT RECEIPT',
            style: 'headerMid',
          },
          {        
            image: this.dsProfileImg,
            alignment: 'left',
            width: 60,
            height: 60,
            margin: [0, 0, 0, 0],
          },
          {        
            text: ' ',
          },
          {        
            text: this.school.companyName,
          },
          {
            text: this.school.fullAddress,
          },
          {
            text: 'Email: ' +this.school.companyEmail,
          },
          {
            text: 'Tel. No.: ' + this.school.telephone + ' | Mobile No.: '+ this.school.mobile,
          },
          {
            text: 'LTO Accreditiation No: '+ this.school.ltoAccreditationNo,
          },
  
          {
            text: 'Payment Details',
            style: 'studentInformationLabel',
          },
          {
            layout: 'noBorders', // optional
            table: {
              widths: [72, 401, 308],
              body: [
                [
                  {
                    text: 'Bill To: ',
                    margin: [0, 15, 0, 0],
                    style: 'label',
                  },
                  {
                    text:
                    this.billToDetails,
                    fillColor: '#f8f8f8',
                    margin: [0, 15, 0, 0],
                    style: 'field',
                  },                                           
                ],
                [
                  {
                    text: 'Reference No.',
                    margin: [0, 15, 0, 0],
                    style: 'label',
                  },
                  {
                    text:
                    this.transaction.paymentRefNumber,
                    fillColor: '#f8f8f8',
                    margin: [0, 15, 0, 0],
                    style: 'field',
                  },
                ],
                [
                {
                  text: 'Date',
                   margin: [0, 15, 0, 0],
                  style: 'label',
                },
                {
                  text:
                  this.paymentDate,
                  fillColor: '#f8f8f8',
                  margin: [0, 15, 0, 0],
                  style: 'field',
                },
              ],
              [
                {
                  text: 'Method',
                  margin: [0, 15, 0, 0],
                  style: 'label',
                },
                {
                  text:
                  this.transaction.paymentMethodName,
                  fillColor: '#f8f8f8',
                  margin: [0, 15, 0, 0],
                  style: 'field',
                },
              ],
              [
                {
                  text: 'Remarks',
                  margin: [0, 15, 0, 0],
                  style: 'label',
                },
                {
                  text: this.transaction.Remarks,
                  fillColor: '#f8f8f8',
                  margin: [0, 15, 0, 0],
                  style: 'field',
                },
              ],
            ]
            },
          },
          {
            text: 'Course Information',
            style: 'studentInformationLabel',
          },
          {
            layout: 'noBorders', // optional
            table: {
              // headers are automatically repeated if the table spans over multiple pages
              // you can declare how many rows should be treated as headers
  
              //widths: [82, 362, 66],
              widths: [72, 401, 308],
  
              body: [
                [
                  {
                    text: 'Name',
                    margin: [0, 15, 0, 0],
                    style: 'label',
                  },
                  {
                    text: this.transaction.courseName,
                    fillColor: '#f8f8f8',
                    margin: [0, 15, 0, 0],
                    style: 'field',
                  },
                ],
                [
                  {
                    text: 'Description',
                    margin: [0, 15, 0, 0],
                    style: 'label',
                  },
                  {
                    text: this.transaction.courseName,
                    fillColor: '#f8f8f8',
                    margin: [0, 15, 0, 0],
                    style: 'field',
                  },
                ],              
                [
                  {
                    text: 'Paid Amount',
                    margin: [0, 15, 0, 0],
                    style: 'label',
                  },
                   {
                    text: 'PHP '+
                    this.formatMoney(this.transaction.paymentTotalAmount)
                    ,
                    fillColor: '#f8f8f8',
                    margin: [0, 15, 0, 0],
                    style: 'field',
                  }, 
                ],
              ],
            },
          },     
          {
            text: '',
            style: 'studentInformationLabel',
          },
          {
            text:'=== This is a computer generated document, the official receipt will be issued by the Driving School ===',
            alignment: 'center',
            style: 'footer',
          },
          {
            text: '',
            style: 'studentInformationLabel',
          },
          {
            text: '© ' + moment(new Date()).format('YYYY')+' inquiry@saferoads.ph',
            style: 'footer',
          },
        ],
  
        styles: {
          headerSmall: {
            fontSize: 15,
            bold: true,
            alignment: 'left',
            color: '#333232',
            margin: [0, 100, 0, 0],
          },
          header: {
            fontSize: 45,
            alignment: 'left',
            color: '#0038a8',
            bold: true,
          },
          forLabel: {
            fontSize: 15,
            bold: true,
            alignment: 'left',
            color: '#333232',
            margin: [0, 0, 0, 0],
          },
          headerMid: {
            fontSize: 15,
            bold: true,
            alignment: 'left',
            color: '#0038a8',
            margin: [0, 24.5, 0, 11],
          },
          studentInformationLabel: {
            fontSize: 12,
            bold: true,
            alignment: 'left',
            color: '#0038a8',
            margin: [0, 24.5, 0, 11],
          },
          label: { fontSize: 10, color: '#333232' },
          field: { fontSize: 10, bold: true, color: '#000000' },
          footer: { fontSize: 6, color: '#333232' },
        },
      };
  
      this.pdfObj = pdfMake.createPdf(dd);
  
      //console.log(this.pdfObj);
  
      var qr = "{ qr: 'text in QR', fit: '500' }";
  
      if (this.plt.is('hybrid')) {
        this.pdfObj.getBase64(async (data) => {
          try {
            let path = `pdf/certificate_${Date.now()}.pdf`;
            const result = await Filesystem.writeFile({
              path,
              data,
              directory: Directory.Documents,
              recursive: true,
            });
  
            this.cmsService.successMessageToast('File Uri : ' + result.uri);
            //console.log('error');
  
            this.fileOpener
              .open(`${result.uri}`, 'application/pdf')
              .then(() => {
                this.loadingCtrl.dismiss();
              })
              .catch((e) => {
                this.cmsService.errorMessageToast('Error in File Opener : ' + e);
                //console.log('error');
                this.loadingCtrl.dismiss();
              });
          } catch (e) {
            this.cmsService.errorMessageToast('Unnable to Write' + e);
            console.error('Unnable to write');
            this.loadingCtrl.dismiss();
          }
        });
        this.fileDownloaded =true;
      } else {
        this.fileDownloaded =true;
        this.pdfObj.download();
        this.loadingCtrl.dismiss();
      }
    }
  }


